import { LoveItBold } from '@ha/icons';
import React from 'react';
import { useIntl } from 'ha/i18n';

import RoundIconButton, {
  RoundIconButtonProps,
} from 'ha/ui/next/RoundIconButton';

interface Props extends RoundIconButtonProps {
  isLoading: boolean;
  isFavorite: boolean;
}

export const FavoriteButtonNext: React.FC<Omit<Props, 'children'>> = ({
  isLoading,
  isFavorite,
  ...props
}) => {
  const { T } = useIntl();

  return (
    <RoundIconButton
      aria-label={isFavorite ? T('Unfavorite') : T('Favorite')}
      title={isFavorite ? T('Unfavorite') : T('Favorite')}
      size="small"
      color="white"
      disabled={isLoading}
      {...props}
    >
      <LoveItBold color={isFavorite ? 'error' : 'action'} fontSize="inherit" />
    </RoundIconButton>
  );
};

export default FavoriteButtonNext;
